import React, { useState } from "react";
import "./ProductPricing.css";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { COLORS } from "../ProductLanding/ProductLanding";
import { CheckCircle } from "react-bootstrap-icons";
import LandingFooter from "../layout/Footer/LandingFooter";
import { Modal, Form, InputGroup } from "react-bootstrap";
import { Person, Telephone, Envelope, XLg } from "react-bootstrap-icons";
import axios from "axios";
import { showMyAlert } from "../../Utils/alertService";

const ProductPricing = () => {
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [planForm, setPlanForm] = useState({
    name: "",
    mobile: "",
    email: "",
  });

  const PRICING_PLANS = [
    {
      id: "starter",
      name: "Starter",
      price: "₹0",
      period: "per month",
      description:
        "Perfect for small teams or startups getting started with payroll.",
      features: [
        "Up to 25 employees",
        "Basic payroll & attendance",
        "Email support",
        "Secure cloud storage",
      ],
      popular: false,
    },
    {
      id: "professional",
      name: "Professional",
      price: "₹999",
      period: "per month",
      description:
        "For growing businesses that need control, automation, and insights.",
      features: [
        "Up to 200 employees",
        "Advanced payroll automation",
        "Leave & shift management",
        "Priority chat support",
      ],
      popular: true, // highlight this one
    },
    {
      id: "enterprise",
      name: "Enterprise",
      price: "₹2,499",
      period: "per month",
      description:
        "Best for large organizations needing full customization and control.",
      features: [
        "Unlimited employees",
        "Custom integrations",
        "Dedicated account manager",
        "Compliance & analytics suite",
      ],
      popular: false,
    },
  ];

  const getISTDateTime = () => {
    const now = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istTime = new Date(now.getTime() + istOffset);

    const day = String(istTime.getUTCDate()).padStart(2, "0");
    const month = String(istTime.getUTCMonth() + 1).padStart(2, "0");
    const year = istTime.getUTCFullYear();
    const hours = String(istTime.getUTCHours()).padStart(2, "0");
    const minutes = String(istTime.getUTCMinutes()).padStart(2, "0");
    const seconds = String(istTime.getUTCSeconds()).padStart(2, "0");

    return {
      date: `${day}-${month}-${year}`,
      time: `${hours}:${minutes}:${seconds}`,
    };
  };

  const handleSubmitPlan = async (e) => {
    e.preventDefault();

    try {
      const { date, time } = getISTDateTime();

      await axios.post(
        "https://api.dremerz.net/api/DZ_8925_PayrollProduct_LandingPage_PlanRequests_Records",
        {
          planName: selectedPlan,
          name: planForm.name,
          mobile: planForm.mobile,
          email: planForm.email,
          submittedDate: date,
          submittedTime: time,
        }
      );

      showMyAlert({
        type: "Success",
        title: "Submitted!",
        message:
          "Your request has been recorded. Our team will contact you soon.",
        duration: 3000,
      });

      setPlanForm({ name: "", mobile: "", email: "" });
      setShowPlanModal(false);
    } catch (err) {
      showMyAlert({
        type: "danger",
        title: "Failed",
        message: "Could not submit. Try again later.",
        duration: 3000,
      });
    }
  };

  return (
    <div
      className="productPricing-root"
      style={{ backgroundColor: COLORS.bgPage, color: COLORS.textDark }}
    >
      <section
        className="productPricing-hero py-5"
        style={{ backgroundColor: COLORS.bgLight }}
      >
        <Container className="px-3 px-lg-5 text-center">
          <h1 className="productPricing-title mb-3">
            Simple, Transparent Pricing
          </h1>
          <p className="productPricing-subtitle mb-5">
            Choose a plan that fits your team’s size and needs. No setup fees,
            no hidden charges.
          </p>

          <Row className="justify-content-center g-4">
            {PRICING_PLANS.map((plan) => (
              <Col key={plan.id} xs={12} md={6} lg={4}>
                <Card
                  className={`productPricing-card ${
                    plan.popular ? "popular" : ""
                  }`}
                >
                  {plan.popular && (
                    <div className="productPricing-badge">Most Popular</div>
                  )}

                  <Card.Body className="d-flex flex-column align-items-center text-center">
                    <h5 className="productPricing-plan-name">{plan.name}</h5>
                    {/* <h2 className="productPricing-plan-price">
                      {plan.price}
                      <small className="text-muted fs-6">/{plan.period}</small>
                    </h2> */}
                    <p className="productPricing-plan-desc">
                      {plan.description}
                    </p>

                    <ul className="list-unstyled my-3">
                      {plan.features.map((f, idx) => (
                        <li
                          key={idx}
                          className="d-flex align-items-center justify-content-center gap-2 text-secondary mb-2"
                        >
                          <CheckCircle
                            size={18}
                            color={COLORS.primary}
                            className="flex-shrink-0"
                          />
                          {f}
                        </li>
                      ))}
                    </ul>

                    <Button
                      className="productPricing-btn mt-auto"
                      style={{
                        backgroundColor: plan.popular
                          ? COLORS.primary
                          : COLORS.white,
                        color: plan.popular ? COLORS.white : COLORS.primary,
                        border: `1px solid ${
                          plan.popular ? COLORS.primary : COLORS.borderSoft
                        }`,
                      }}
                      onClick={() => {
                        setSelectedPlan(plan.name);
                        setShowPlanModal(true);
                      }}
                    >
                      Get Started
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      <Modal
        show={showPlanModal}
        onHide={() => setShowPlanModal(false)}
        size="lg"
        centered
        className="planModal-root"
      >
        <Modal.Body className="p-0">
          <Row className="g-0">
            {/* LEFT */}
            <Col md={5} className="planModal-left-pane position-relative">
              <Button
                className="planModal-close-btn position-absolute top-0 end-0 m-2 d-md-none"
                onClick={() => setShowPlanModal(false)}
              >
                <XLg size={20} color="black" />
              </Button>

              <div>
                <h4>
                  Begin your{" "}
                  <span style={{ color: COLORS.primary }}>{selectedPlan}</span>{" "}
                  plan
                </h4>
                <p>Share your basic details and we’ll reach out.</p>
              </div>

              <blockquote>
                “Choosing the right plan starts with understanding your needs.”
              </blockquote>
            </Col>

            {/* RIGHT */}
            <Col md={7} className="planModal-form-pane">
              <Button
                className="planModal-close-btn position-absolute top-0 end-0 m-2 d-none d-md-flex"
                onClick={() => setShowPlanModal(false)}
              >
                <XLg size={20} color="black" />
              </Button>

              <h4 className="planModal-title">Submit for {selectedPlan}</h4>

              <Form onSubmit={handleSubmitPlan}>
                <Form.Group className="mb-3">
                  <InputGroup className="planModal-input-group">
                    <InputGroup.Text>
                      <Person />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Your name"
                      value={planForm.name}
                      onChange={(e) =>
                        setPlanForm({ ...planForm, name: e.target.value })
                      }
                      required
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group className="mb-3">
                  <InputGroup className="planModal-input-group">
                    <InputGroup.Text>
                      <Telephone />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Mobile number"
                      value={planForm.mobile}
                      onChange={(e) =>
                        setPlanForm({ ...planForm, mobile: e.target.value })
                      }
                      required
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group className="mb-3">
                  <InputGroup className="planModal-input-group">
                    <InputGroup.Text>
                      <Envelope />
                    </InputGroup.Text>
                    <Form.Control
                      type="email"
                      placeholder="Email (optional)"
                      value={planForm.email}
                      onChange={(e) =>
                        setPlanForm({ ...planForm, email: e.target.value })
                      }
                    />
                  </InputGroup>
                </Form.Group>

                <Button type="submit" className="planModal-submit-btn">
                  Submit Request
                </Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <LandingFooter />
    </div>
  );
};

export default ProductPricing;
